<template>
    <v-container fluid>
        <!-- KPI -->
        <v-row class="mb-2">
            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Macchine</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.totaleMacchine ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Totali censite</div>
                            </div>
                            <v-avatar color="blue-lighten-4" size="44">
                                <v-icon color="primary">mdi-cog</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Attive</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.macchineAttive ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">In produzione</div>
                            </div>
                            <v-avatar color="green-lighten-4" size="44">
                                <v-icon color="success">mdi-check-circle</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Macro aree</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.macroAree ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Configurate</div>
                            </div>
                            <v-avatar color="purple-lighten-4" size="44">
                                <v-icon color="deep-purple">mdi-map-marker-radius</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Reparti</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.reparti ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Configurati</div>
                            </div>
                            <v-avatar color="orange-lighten-4" size="44">
                                <v-icon color="orange-darken-2">mdi-office-building</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Filtri -->
        <v-row class="align-center mb-2">
            <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="ricerca" label="Cerca macchina" prepend-inner-icon="mdi-magnify"
                    density="compact" variant="outlined" hide-details clearable />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="macroAreaId" :items="macroAree" item-title="nome" item-value="id"
                    label="Tutte le macro aree" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="onCambioMacroArea" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="repartoId" :items="repartiFiltrati" item-title="nome" item-value="id"
                    label="Tutti i reparti" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="stato" :items="statiDisponibili" item-title="label" item-value="value"
                    label="Tutti gli stati" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
        </v-row>

        <v-row class="align-center mb-2">
            <v-col cols="12" sm="auto" class="mr-auto">
                <span class="text-body-2 text-medium-emphasis">
                    {{ macchine.length }} macchin{{ macchine.length === 1 ? 'a trovata' : 'e trovate' }}
                </span>
            </v-col>
            <v-col cols="auto">
                <v-btn-toggle v-model="vista" mandatory color="primary" density="comfortable" class="rounded-lg"
                    @update:modelValue="salvaVista">
                    <v-btn value="griglia" variant="text" icon="mdi-view-grid" />
                    <v-btn value="elenco" variant="text" icon="mdi-view-list" />
                </v-btn-toggle>
            </v-col>
            <v-col cols="12" sm="auto" v-if="puoScrivere">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">
                    Nuova macchina
                </v-btn>
            </v-col>
        </v-row>

        <!-- Vista griglia -->
        <v-row v-if="vista === 'griglia'">
            <v-col v-for="m in macchine" :key="m.id" cols="12" sm="6" md="4" lg="3">
                <v-card variant="outlined" class="rounded-lg macchina-card" @click="vaiDettaglio(m.id)">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div class="font-weight-bold text-body-1">{{ m.nome }}</div>
                            <v-chip size="small" :color="coloreStato(m.stato)" variant="flat">
                                {{ etichettaStato(m.stato) }}
                            </v-chip>
                        </div>
                        <div class="text-caption text-medium-emphasis">{{ m.codice || '—' }}</div>
                        <div class="text-caption mt-2">{{ m.macroAreaNome }}<template v-if="m.repartoNome">
                                / {{ m.repartoNome }}</template></div>
                        <div class="text-caption mt-2">
                            <div><span class="text-medium-emphasis">Ultima manutenzione:</span>
                                {{ formatData(m.ultimaManutenzioneData) }}</div>
                            <div><span class="text-medium-emphasis">Prossima manutenzione:</span>
                                {{ formatData(m.prossimaManutenzioneData) }}</div>
                        </div>
                    </v-card-text>
                    <v-card-actions v-if="puoScrivere">
                        <v-spacer />
                        <v-btn icon variant="text" size="small" title="Duplica" @click.stop="duplica(m)">
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn icon variant="text" size="small" @click.stop="apriDialog(m)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon variant="text" size="small" color="error" @click.stop="chiediEliminazione(m)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" v-if="macchine.length === 0">
                <div class="text-center text-medium-emphasis pa-8">Nessuna macchina trovata con questi filtri.</div>
            </v-col>
        </v-row>

        <!-- Vista elenco -->
        <v-data-table v-else :headers="headers" :items="macchine" :items-per-page="15" density="comfortable">
            <template #[`item.nome`]="{ item }">
                <a href="#" class="text-primary" @click.prevent="vaiDettaglio(item.id)">{{ item.nome }}</a>
            </template>

            <template #[`item.stato`]="{ item }">
                <v-chip size="small" :color="coloreStato(item.stato)" variant="flat">
                    {{ etichettaStato(item.stato) }}
                </v-chip>
            </template>

            <template #[`item.ultimaManutenzioneData`]="{ item }">
                {{ formatData(item.ultimaManutenzioneData) }}
            </template>

            <template #[`item.prossimaManutenzioneData`]="{ item }">
                {{ formatData(item.prossimaManutenzioneData) }}
            </template>

            <template #[`item.manutenzioniScadute`]="{ item }">
                <v-chip v-if="item.manutenzioniScadute > 0" size="small" color="error" variant="flat">
                    {{ item.manutenzioniScadute }} scadute
                </v-chip>
                <span v-else class="text-medium-emphasis">—</span>
            </template>

            <template #[`item.azioni`]="{ item }" v-if="puoScrivere">
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Dialog creazione/modifica -->
        <dialog-macchina v-model="dialog" :macchina="macchinaSelezionata" @salvato="onSalvato" />

        <!-- Dialog conferma eliminazione -->
        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>
                    La macchina "{{ macchinaDaEliminare?.nome }}" verrà rimossa (spostata nello storico).
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog di conflitto: la macchina ha manutenzioni collegate, mostrate prima
             di chiedere la conferma definitiva dell'eliminazione a cascata. -->
        <v-dialog v-model="dialogConflitto" max-width="480">
            <v-card>
                <v-card-title>La macchina ha manutenzioni collegate</v-card-title>
                <v-card-text>
                    <div class="mb-2">{{ conflittoMessaggio }}</div>
                    <v-list density="compact">
                        <v-list-item v-for="el in conflittoElementi" :key="el.id"
                            :title="formatData(el.data)" :subtitle="el.stato" />
                    </v-list>
                    <div class="mt-2 text-error">Procedendo verranno eliminate anche tutte queste manutenzioni.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogConflitto = false">Annulla</v-btn>
                    <v-btn color="error" @click="eliminaComunque">Elimina comunque</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DialogMacchina from "@/components/macchine/DialogMacchina.vue";
import { STATI_MACCHINA, coloreStato, etichettaStato } from "@/constants/statoMacchina.js";
import { leggiFiltriDaQuery, scriviFiltriSuQuery } from "@/utils/filtriUrl.js";

export default {
    name: "MacchinePage",

    components: {
        DialogMacchina,
    },

    data() {
        return {
            ricerca: "",
            macroAreaId: null,
            repartoId: null,
            stato: null,
            vista: localStorage.getItem("macchine.vista") || "griglia",
            dialog: false,
            macchinaSelezionata: null,
            dialogElimina: false,
            macchinaDaEliminare: null,
            dialogConflitto: false,
            conflittoMessaggio: "",
            conflittoElementi: [],
            debounce: null,
            statiDisponibili: STATI_MACCHINA,
            headers: [
                { title: "Nome", key: "nome" },
                { title: "Codice", key: "codice" },
                { title: "Reparto", key: "repartoNome" },
                { title: "Macro area", key: "macroAreaNome" },
                { title: "Stato", key: "stato" },
                { title: "Ultima manutenzione", key: "ultimaManutenzioneData" },
                { title: "Prossima manutenzione", key: "prossimaManutenzioneData" },
                { title: "Manutenzioni", key: "manutenzioniScadute" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        macchine() {
            return this.$store.getters["macchine/lista"];
        },
        kpi() {
            return this.$store.getters["macchine/kpi"] || {};
        },
        reparti() {
            return this.$store.getters["configurazione/reparti"];
        },
        macroAree() {
            return this.$store.getters["configurazione/macroAree"];
        },
        repartiFiltrati() {
            if (!this.macroAreaId) return this.reparti;
            return this.reparti.filter(r => r.macroAreaId === this.macroAreaId);
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
    },

    watch: {
        ricerca() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => this.carica(), 300);
        },
    },

    mounted() {
        Object.assign(this, leggiFiltriDaQuery(this.$route, {
            ricerca: "string",
            macroAreaId: "number",
            repartoId: "number",
            stato: "string",
        }));
        this.$store.dispatch("configurazione/caricaMacroAree");
        this.$store.dispatch("configurazione/caricaReparti");
        this.$store.dispatch("macchine/caricaKpi");
        this.carica();
    },

    methods: {
        async carica() {
            scriviFiltriSuQuery(this.$router, this.$route, {
                ricerca: this.ricerca || undefined,
                macroAreaId: this.macroAreaId || undefined,
                repartoId: this.repartoId || undefined,
                stato: this.stato || undefined,
            });
            try {
                await this.$store.dispatch("macchine/carica", {
                    search: this.ricerca || undefined,
                    macroAreaId: this.macroAreaId || undefined,
                    repartoId: this.repartoId || undefined,
                    stato: this.stato || undefined,
                });
            } catch (error) {
                console.log(error);
            }
        },

        onCambioMacroArea() {
            this.repartoId = null;
            this.carica();
        },

        salvaVista(v) {
            localStorage.setItem("macchine.vista", v);
        },

        vaiDettaglio(id) {
            this.$router.push({ path: `/macchine/${id}` });
        },

        apriDialog(item) {
            this.macchinaSelezionata = item;
            this.dialog = true;
        },

        onSalvato() {
            this.carica();
            this.$store.dispatch("macchine/caricaKpi");
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("macchine/duplica", item.id);
                this.carica();
                this.$store.dispatch("macchine/caricaKpi");
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(item) {
            this.macchinaDaEliminare = item;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("macchine/elimina", { id: this.macchinaDaEliminare.id });
                this.carica();
                this.$store.dispatch("macchine/caricaKpi");
                this.dialogElimina = false;
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    this.conflittoMessaggio = error.response.data.message;
                    this.conflittoElementi = error.response.data.elementi || [];
                    this.dialogElimina = false;
                    this.dialogConflitto = true;
                } else {
                    console.log(error);
                    this.dialogElimina = false;
                }
            }
        },

        async eliminaComunque() {
            try {
                await this.$store.dispatch("macchine/elimina", { id: this.macchinaDaEliminare.id, conferma: true });
                this.carica();
                this.$store.dispatch("macchine/caricaKpi");
            } catch (error) {
                console.log(error);
            }
            this.dialogConflitto = false;
        },

        coloreStato,
        etichettaStato,

        formatData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "—";
        },
    },
};
</script>

<style scoped>
.macchina-card {
    cursor: pointer;
    transition: border-color 0.15s, background-color 0.15s;
}

.macchina-card:hover {
    border-color: rgb(var(--v-theme-primary));
}
</style>
